<script>
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from 'dayjs';

    import Step1SlotConfig from './Step1SlotConfig.vue'; // Step 1
    import Step2SlotPeriod from './Step2SlotPeriod.vue'; // Step 2

    import StepperHeader from './StepperHeader.vue';
    import ActionBar from './ActionBar.vue';


    export default {
        name: 'BottomSheet', // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-step1-slotconfig': Step1SlotConfig,
            'sdr-step2-slotperiod': Step2SlotPeriod,
            'sdr-stepper-header': StepperHeader,
            'sdr-stepper-action-bar': ActionBar

		},

        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean], // 'showSheet' itself
            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            eventRecord: Object // 'update'

        }, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid: false,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || 'Field is required';
                    },
                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },
                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },
                    reqIfWeekly(v, flightDateType) {
                        return flightDateType === 0 || v === 0 || (v || '').toString().length > 0 || 'Field is required';
                    },
                    reqIfActiveTab(v, isActiveTab) {
                        return isActiveTab === false || (v || '').toString().length > 0 || 'Field is required';
                    },
                    isFlightNo(v) {
                        return (v === null || v === '' || v === undefined) || /^[A-Za-z0-9]{1,3}\d{1,4}[a-z]{0,1}$/i.test(v) || 'Invalid Flight#';
                    }
                },
                // >>> ------------------------------------ 'CRUD Config'
                crudData: {
                    firstLeg: {
                        input_Season: '',
                        input_Direction: '',
                        input_AircraftConfig: '',
                        input_FlightType: '',
                        input_FlightNo: '',
                        input_Airport: '',
                        input_Slot_Airport: '',
                        input_Slot_Time: '',
                        input_FromDate: '',
                        input_ToDate: '',
                        input_dateRange: '',
                        input_Slot_Status: '',
                        input_dow: []
                    },
                    secondLeg: {
                        input_Season: '',
                        input_Direction: '',
                        input_AircraftConfig: '',
                        input_FlightType: '',
                        input_FlightNo: '',
                        input_Airport: '',
                        input_Slot_Airport: '',
                        input_Slot_Time: '',
                        input_dateRange: '',
                        input_Slot_Status: '',
                        input_dow: []
                    }
                },
                // >>> ------------------------------------ 'Stepper Errors'
                validation: { step1: true, step2: true },
                activeStepper: '1',
                // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                // >>> ------------------------------------ 'Utils'
                sheetAlreadyOpen: false,
                // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194,
                // >>> ------------------------------------ 'Form Stepper'
                formStepper: 1
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports'
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {
                    const me = this,
                          eventRecord = me.eventRecord;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                    if (me.value === true && me.sheetAlreadyOpen === false) { // we're opening so initialize data
                    // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194

                        // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                        // remember that the sheet is opened and INITIALIZED
                        me.sheetAlreadyOpen = true;
                        // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194

                        // >>> ------------------ reset validation
                        if (me.$refs.form !== undefined) {
                            me.$refs.form.resetValidation();
                        }

                    }

                    // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #194
                    // on closing the sheet, reset the util variables too
                    if (me.value === false) {
                        me.sheetAlreadyOpen = false;
                    }
                    // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #194


                    return this.value;

                }, // eo function sheetShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    this.$emit('input', value);

                } // eo function sheetShown set()

            } // eo sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> created');

        }, // eo function created()
        /* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> destroyed');

        }, //eo function created()
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_slotmanagement_createUpdateSlots'
            ]),


            //---------------------------------------------------------------------/
            // #
            // #    /$$$$$$                                                   /$$
            // #   /$$__  $$                                                 | $$
            // #  | $$  \__/  /$$$$$$  /$$$$$$$   /$$$$$$   /$$$$$$  /$$$$$$ | $$
            // #  | $$ /$$$$ /$$__  $$| $$__  $$ /$$__  $$ /$$__  $$|____  $$| $$
            // #  | $$|_  $$| $$$$$$$$| $$  \ $$| $$$$$$$$| $$  \__/ /$$$$$$$| $$
            // #  | $$  \ $$| $$_____/| $$  | $$| $$_____/| $$      /$$__  $$| $$
            // #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$| $$     |  $$$$$$$| $$
            // #   \______/  \_______/|__/  |__/ \_______/|__/      \_______/|__/
            // #
            //--------------------------------------------------------------------/
            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onClick_CloseSheet');
                me.sheetShown = false;

            }, // eo onClick_CloseSheet()

            // #    /$$$$$$  /$$$$$$$  /$$$$$$$$  /$$$$$$  /$$$$$$$$/$$$$$$$$
            // #   /$$__  $$| $$__  $$| $$_____/ /$$__  $$|__  $$__/ $$_____/
            // #  | $$  \__/| $$  \ $$| $$      | $$  \ $$   | $$  | $$
            // #  | $$      | $$$$$$$/| $$$$$   | $$$$$$$$   | $$  | $$$$$
            // #  | $$      | $$__  $$| $$__/   | $$__  $$   | $$  | $$__/
            // #  | $$    $$| $$  \ $$| $$      | $$  | $$   | $$  | $$
            // #  |  $$$$$$/| $$  | $$| $$$$$$$$| $$  | $$   | $$  | $$$$$$$$
            // #   \______/ |__/  |__/|________/|__/  |__/   |__/  |________/
            // #
            // #
            // #
            /*******************************************************************
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            */
            onAssign_Create: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    // >>> ------------------------------------ 'CRUD Config'
                    crudData: {
                        firstLeg: {
                            input_Season: '',
                            input_Direction: 'DEPARTURE',
                            input_AircraftConfig: '',
                            input_FlightType: '',
                            input_FlightNo: '',
                            input_Airport: '',
                            input_Slot_Airport: '',
                            input_Slot_Time: '',
                            input_FromDate: '',
                            input_ToDate: '',
                            input_NumberOfWeeks: '',
                            input_Slot_Status: '',
                            input_dow: []
                        },
                        secondLeg: {
                            input_Season: '',
                            input_Direction: 'ARRIVAL',
                            input_AircraftConfig: '',
                            input_FlightType: '',
                            input_FlightNo: '',
                            input_Airport: '',
                            input_Slot_Airport: '',
                            input_Slot_Time: '',
                            input_dateRange: '',
                            input_Slot_Status: '',
                            input_dow: []
                        }
                    }
                });

            }, // eof onAssign_Create()

            //-----------------------------------------------------------------/
            // #
            // #  /$$   /$$                 /$$             /$$
            // # | $$  | $$                | $$            | $$
            // # | $$  | $$  /$$$$$$   /$$$$$$$  /$$$$$$  /$$$$$$    /$$$$$$
            // # | $$  | $$ /$$__  $$ /$$__  $$ |____  $$|_  $$_/   /$$__  $$
            // # | $$  | $$| $$  \ $$| $$  | $$  /$$$$$$$  | $$    | $$$$$$$$
            // # | $$  | $$| $$  | $$| $$  | $$ /$$__  $$  | $$ /$$| $$_____/
            // # |  $$$$$$/| $$$$$$$/|  $$$$$$$|  $$$$$$$  |  $$$$/|  $$$$$$$
            // #  \______/ | $$____/  \_______/ \_______/   \___/   \_______/
            // #           | $$
            // #           | $$
            // #           |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> ------------------------------------ 'CRUD Config'
                    crudData: {
                        firstLeg: {
                            firstLeg: {
                                input_Season: '',
                                input_Direction: eventRecord.direction,
                                input_AircraftConfig: eventRecord.aircraftType,
                                input_FlightType: eventRecord.flightType,
                                input_FlightNo: eventRecord.flightNo,
                                input_Airport: me.get_Airports.find(a => a.aptCode === eventRecord.airport),
                                input_Slot_Airport: me.get_Airports.find(a => a.aptCode === eventRecord.airportSlot),
                                input_Slot_Time: dayjs(eventRecord.slotTime).utc().format('HH:mm'),
                                input_dateRange: dayjs(eventRecord.slotTime).format('YYYY-MM-DD'),
                                input_Slot_Status: eventRecord.status,
                                input_dow: []
                            },
                            secondLeg: {
                                input_Season: '',
                                input_Direction: eventRecord.direction,
                                input_AircraftConfig: eventRecord.aircraftType,
                                input_FlightType: eventRecord.flightType,
                                input_FlightNo: eventRecord.flightNo,
                                input_Airport: me.get_Airports.find(a => a.aptCode === eventRecord.airport),
                                input_Slot_Airport: me.get_Airports.find(a => a.aptCode === eventRecord.airportSlot),
                                input_Slot_Time: dayjs(eventRecord.slotTime).utc().format('HH:mm'),
                                input_dateRange: dayjs(eventRecord.slotTime).format('YYYY-MM-DD'),
                                input_Slot_Status: eventRecord.status,
                                input_dow: []
                            }
                        }
                    }
                });

            }, // eof onAssign_Update()


            // #   /$$$$$$$  /$$$$$$$$  /$$$$$$  /$$$$$$$$/$$$$$$$$
            // #  | $$__  $$| $$_____/ /$$__  $$| $$_____/__  $$__/
            // #  | $$  \ $$| $$      | $$  \__/| $$        | $$
            // #  | $$$$$$$/| $$$$$   |  $$$$$$ | $$$$$     | $$
            // #  | $$__  $$| $$__/    \____  $$| $$__/     | $$
            // #  | $$  \ $$| $$       /$$  \ $$| $$        | $$
            // #  | $$  | $$| $$$$$$$$|  $$$$$$/| $$$$$$$$  | $$
            // #  |__/  |__/|________/ \______/ |________/  |__/
            // #
            // #
            // #
            /*******************************************************************
            * onAssign_Reset()
            *
            * Desc: Resets CrudData.
            * Note:
            *
            */
            onAssign_Reset: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onAssign_Reset');
                Object.assign(me, {
                    // >>> ------------------------------------ 'CRUD Config'
                    // >>> ------------------------------------ 'CRUD Config'
                    crudData: {
                        firstLeg: {
                            input_Season: '',
                            input_Direction: '',
                            input_AircraftConfig: '',
                            input_FlightType: '',
                            input_FlightNo: '',
                            input_Airport: '',
                            input_Slot_Airport: '',
                            input_Slot_Time: '',
                            input_dateRange: '',
                            input_Slot_Status: '',
                            input_dow: []
                        },
                        secondLeg: {
                            input_Season: '',
                            input_Direction: '',
                            input_AircraftConfig: '',
                            input_FlightType: '',
                            input_FlightNo: '',
                            input_Airport: '',
                            input_Slot_Airport: '',
                            input_Slot_Time: '',
                            input_dateRange: '',
                            input_Slot_Status: '',
                            input_dow: []
                        }
                    },
                    validation: { step1: true, step2: true },
                    activeStepper: '1'
                });

            }, // eof onAssign_Reset()


            //-----------------------------------------------------------------/
            // #
            // #   /$$    /$$          /$$ /$$       /$$             /$$     /$$
            // #  | $$   | $$         | $$|__/      | $$            | $$    |__/
            // #  | $$   | $$ /$$$$$$ | $$ /$$  /$$$$$$$  /$$$$$$  /$$$$$$   /$$  /$$$$$$  /$$$$$$$
            // #  |  $$ / $$/|____  $$| $$| $$ /$$__  $$ |____  $$|_  $$_/  | $$ /$$__  $$| $$__  $$
            // #   \  $$ $$/  /$$$$$$$| $$| $$| $$  | $$  /$$$$$$$  | $$    | $$| $$  \ $$| $$  \ $$
            // #    \  $$$/  /$$__  $$| $$| $$| $$  | $$ /$$__  $$  | $$ /$$| $$| $$  | $$| $$  | $$
            // #     \  $/  |  $$$$$$$| $$| $$|  $$$$$$$|  $$$$$$$  |  $$$$/| $$|  $$$$$$/| $$  | $$
            // #      \_/    \_______/|__/|__/ \_______/ \_______/   \___/  |__/ \______/ |__/  |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form{}
            *
            * Desc:
            * Note:
            *
            */
            onValidate_Form: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onValidate_Form');
                me.validateFormStepper('1');
                me.validateFormStepper('2');

                if (this.$refs.form.validate() === false) {
                    return;
                }

                me.onValidated_Form_CallAction();

            }, // eo function onValidate_Form()


            /*******************************************************************
            * onValidated_Form_CallAction()
            *
            * Desc: Shoots Action Calls based on editorMode AFTER validation.
            * Note:
            *
            */
            onValidated_Form_CallAction: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onValidated_Form_CallAction');
                if (me.editorMode === 'create') {
                    me.actn_call_slotmanagement_createUpdateSlots({ loadingMask: true, payload: me.createSlotPayload() });
                } else if (me.editorMode === 'create') {
                    me.createUpdateFlightsPayload();
                }

            }, // eo function onValidated_Form_CallAction()


            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onClick_StepperHeader');
                //window.dispatchEvent(new Event('resize'));

                switch (me.activeStepper) {
                    case '1':
                        if (me.validation.step1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    case '2':
                        if (me.validation.step2 === false) {
                            me.validateFormStepper('2');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            }, // eo function onClick_StepperHeader()


            /*******************************************************************
            * validateInputFields()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Object | null}
            */
            validateInputFields: function(element) {

                const me = this;
                let valid = true;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> validateInputFields');
                if ('type' in element) { // ;-)
                    return element.valid !== undefined ? element.valid : true;
                } else {
                    if (element.$children.length > 0) {
                        element.$children.forEach(child => {
                            valid = valid && this.validateInputFields(child);
                        });
                    }
                }


                return valid;

            }, // eo function validateInputFields()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            * Note: Step 2 is disabled on "update" mode. So we have to skip
            * Note: step 2 validation on update (ref is undefined).
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                const me = this;
                let stepperIsValid = true,
                    child = null,
                    stepperRef = null;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> validateFormStepper');
                switch (stepperNumber) {
                    case '1':
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    case '2':
                        stepperRef = this.$refs.stepperContent2;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }

                // clean up
                if (stepperRef === undefined) {
                    stepperRef = null;
                }


                if (stepperRef !== null) {
                    for (let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        stepperIsValid = this.validateInputFields(child);
                    }
                }


                switch (stepperNumber) {
                    case '1':
                        this.validation.step1 = stepperIsValid;
                        break;
                    case '2':
                        this.validation.step2 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            }, // eo function validateFormStepper()

            /*******************************************************************
            * onChange_TabChange()
            *
            * Desc: Resets the rules state on tab change. (Step2RouteConfig + Step3RouteConfig)
            * Note:
            *
            */
            onChange_TabChange: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/slotmanagement/components/core/slots/BottomSheet.vue >>> onChange_TabChange');
                me.$refs.form.resetValidation();

            } // eof onChange_TabChange()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        /* max-height:700px; */
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }


    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }

    @keyframes glowing {
        0% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
        40% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        60% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        100% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
    }

    .input-glow {
        animation: glowing 1500ms 1;
    }

</style>

<style>
    /* BottomSheet Wide Classes to get responsibility */
    .smallDisplay .container {
        max-width: 100vw !important;
    }
    /* BottomSheet Wide Classes to get responsibility */

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 90%;
    }

</style>
